import BannerNotificationsContainer from './BannerNotificationsContainer';
import useGetUserData from '../../hooks/useGetUserData';
import AlertBannerContainer from '../../components/UtilityBanners/AlertBannerContainer';
import DeveloperBanner from '../../components/UtilityBanners/DeveloperBanner';
import FireAlarmBannerContainer from '../../components/UtilityBanners/FireAlarmBanner/FireAlarmBannerContainer';
import ImpersonationBanner from '../../components/UtilityBanners/ImpersonationBanner';
import SandboxBanner from '../../components/UtilityBanners/SandboxBanner/SandboxBanner';
import { capabilities } from 'navigation-components/capabilities';
import { useInvokeCapability } from 'navigation-components/consumer/hooks';
import { memo, useEffect, useMemo, useRef } from 'react';
import { NavigationComponent } from 'navigation-components/consumer/components';
import { bannerNotificationsComponentDef } from 'navigation-components/config';
import ErrorBoundary from '../../components/ErrorBoundary';
import { NavMarker } from 'react-rhumb';
import { isHealthCheck } from '../../utils/isHealthCheck';
import useInterceptAnchorNavigation from '../../hooks/useInterceptAnchorNavigation';
import isBannersDisabled from './isBannersDisabled';
import isHubless from '../../utils/isHubless';
import { BrowserNotificationsServiceWorker } from '../../components/BrowserNotifications/BrowserNotificationsServiceWorker';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BaseBannerContainer = /*#__PURE__*/memo(({
  children
}) => {
  const bannersDisabled = useMemo(isBannersDisabled, []);
  const containerRef = useRef(null);
  const changeIframeStyle = useInvokeCapability(capabilities.RESTYLE_CAP);
  useInterceptAnchorNavigation();
  useEffect(() => {
    const bannerContainer = containerRef.current;
    if (!bannerContainer) return;
    const resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        const {
          height
        } = entry.contentRect;
        changeIframeStyle({
          style: {
            height
          },
          merge: true
        });
      }
    });
    resizeObserver.observe(bannerContainer);
    return () => {
      if (bannerContainer) {
        resizeObserver.unobserve(bannerContainer);
      }
    };
  }, [changeIframeStyle]);
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    boundaryName: "BANNERS_ERROR",
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: "BANNERS_LOAD"
      }), !bannersDisabled && /*#__PURE__*/_jsx("div", {
        ref: containerRef,
        children: children
      })]
    })
  });
});
const BannersComponent = /*#__PURE__*/memo(() => {
  const userData = useGetUserData();
  return /*#__PURE__*/_jsxs(BaseBannerContainer, {
    children: [/*#__PURE__*/_jsx(FireAlarmBannerContainer, {}), /*#__PURE__*/_jsx(AlertBannerContainer, {}), /*#__PURE__*/_jsx(DeveloperBanner, {}), /*#__PURE__*/_jsx(SandboxBanner, {}), userData && /*#__PURE__*/_jsx(ImpersonationBanner, {
      userData: userData
    }), /*#__PURE__*/_jsx(BannerNotificationsContainer, {}), /*#__PURE__*/_jsx(BrowserNotificationsServiceWorker, {})]
  });
});
const HublessBannersComponent = /*#__PURE__*/memo(() => /*#__PURE__*/_jsx(BaseBannerContainer, {
  children: /*#__PURE__*/_jsx(FireAlarmBannerContainer, {})
}));
const AllBannersContainer = () => {
  const component = isHubless() ? HublessBannersComponent : BannersComponent;
  return /*#__PURE__*/_jsx(NavigationComponent, {
    enableStandaloneMode: isHealthCheck,
    definition: bannerNotificationsComponentDef,
    component: component,
    definitionParams: {
      gates: []
    }
  });
};
export default /*#__PURE__*/memo(AllBannersContainer);